/* Bootstrap 5 JS components pack — Phase 4 */
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
